(function(angular, module) {var TagUrl,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

TagUrl = (function() {
  function TagUrl(tagTypes, defaults) {
    if (tagTypes == null) {
      tagTypes = [];
    }
    if (defaults == null) {
      defaults = {};
    }
    this.removeTag = bind(this.removeTag, this);
    this.tags = [];
    this.params = {};
    this.extraParamNames = [];
    this.addTagTypes(tagTypes, defaults);
  }

  Object.defineProperties(TagUrl.prototype, {
    queryString: {
      get: function() {
        var tags;
        tags = this.tags.concat(this.extraParamNames);
        tags = "{" + tags.join('}&{') + "}";
        return tags;
      }
    },
    allTagTypes: {
      get: function() {
        return angular.injector(['ng', 'dybTags']).get('TagTypes');
      }
    }
  });

  TagUrl.prototype.clone = function() {
    return angular.copy(this);
  };

  TagUrl.prototype.addExtraParam = function(name, config, inUrl) {
    var urlName;
    if (inUrl == null) {
      inUrl = true;
    }
    urlName = name;
    if (angular.isString(config)) {
      config = {
        value: config,
        squash: true
      };
    }
    if (config.type != null) {
      urlName += ":" + config.type;
      delete config.type;
    }
    this.params[name] = config;
    if (inUrl) {
      this.extraParamNames.push(urlName);
    }
    return this;
  };

  TagUrl.prototype.addPagerParams = function() {
    this.addExtraParam('page', {
      value: 1,
      type: 'int',
      squash: true
    });
    return this;
  };

  TagUrl.prototype.addSorterParams = function(column, direction) {
    if (direction == null) {
      direction = 'asc';
    }
    this.addExtraParam('sort', {
      value: column,
      squash: true
    });
    this.addExtraParam('direction', {
      value: direction,
      squash: true
    });
    return this;
  };

  TagUrl.prototype.addTag = function(name, defaultValue) {
    var index;
    index = this.tags.indexOf(name);
    if (index === -1) {
      this.tags.push(name);
      this.params[name] = {
        array: true,
        squash: true
      };
      this.setTagDefault(name, defaultValue);
    }
    return this;
  };

  TagUrl.prototype.removeTag = function(name) {
    var index;
    index = this.tags.indexOf(name);
    if (index >= 0) {
      this.tags.splice(index, 1);
      delete this.params[name];
    }
    return this;
  };

  TagUrl.prototype.setTagDefault = function(name, value) {
    var ref;
    if (value != null) {
      value = angular.isArray(value) ? value : [value];
      if ((ref = this.params[name]) != null) {
        ref.value = value;
      }
    } else {
      delete this.params[name].value;
    }
    return this;
  };

  TagUrl.prototype.addTagType = function(type, defaults) {
    var i, len, name, ref;
    if (defaults == null) {
      defaults = {};
    }
    ref = this.allTagTypes[type] || [];
    for (i = 0, len = ref.length; i < len; i++) {
      name = ref[i];
      this.addTag(name, defaults[name]);
    }
    return this;
  };

  TagUrl.prototype.addTagTypes = function(types, defaults) {
    var i, len, type;
    if (defaults == null) {
      defaults = {};
    }
    for (i = 0, len = types.length; i < len; i++) {
      type = types[i];
      this.addTagType(type, defaults);
    }
    return this;
  };

  TagUrl.prototype.addDefaults = function(params) {
    var i, len, name, ref;
    ref = this.tags;
    for (i = 0, len = ref.length; i < len; i++) {
      name = ref[i];
      if ((params[name] == null) && (this.params[name].value != null)) {
        params[name] = this.params[name].value;
      }
    }
  };

  TagUrl.prototype.addEmptyTags = function(params) {
    var i, len, name, ref;
    ref = this.tags;
    for (i = 0, len = ref.length; i < len; i++) {
      name = ref[i];
      params[name] = params[name] || [];
      if (params[name].length === 0 && this.params[name].value) {
        params[name] = true;
      }
    }
  };

  TagUrl.prototype.buildUrl = function(baseUrl) {
    var sep;
    if (baseUrl == null) {
      baseUrl = '';
    }
    sep = indexOf.call(baseUrl, '?') >= 0 ? '&' : '?';
    return baseUrl + sep + this.queryString;
  };

  return TagUrl;

})();

module.constant('TagUrl', TagUrl);
})(angular, angular.module("dybTags"));